import api from "@/services/apiClient";
import type { ProductVersionsIntr } from "@/features/deployment/types/deployment.types";

export const deploymentService = {
	GetProductVersions: (): Promise<ProductVersionsIntr[]> => api.get("Deployment/GetProductVersion").then((res) => res.data),

}